import api from '../api/apiClient';
import { resolveAgentName } from '../../utils/agentName';

// nginx maps /ai-explorer/api/* → the AI microservice /api/*, so the router
// mounted at /api/v1/ai-explorer is reached as /ai-explorer/api/v1/ai-explorer.
const AI = '/ai-explorer/api/v1';
const RISKY_LEVELS = new Set(['medium', 'high', 'critical']);

/**
 * Custom Agents intent-analysis service.
 *
 * Shaped to match geminiEnterpriseAgentsService / copilotService so the shared
 * Intent Analysis page (src/pages/gemini/agents/intent-analysis) renders
 * unchanged when injected via AgentServiceProvider.
 */
export const customAgentsIntentService = {
  async getIntentAnalysis(params = {}) {
    try {
      const { data } = await api.get(`${AI}/ai-explorer/intent-analysis`, { params });
      return {
        summary: data.summary || { total_analyzed: 0, categories_detected: 0, risky_intents: 0 },
        categories: data.categories || [],
        distribution: data.distribution || {},
        intents: (data.intents || []).map((i) => {
          const riskLevel = String(i.risk_level || 'none').trim().toLowerCase();
          return {
            interaction_id: i.interaction_id,
            category: i.category || 'uncategorized',
            confidence: i.confidence || 0,
            query: i.query || '',
            agent_name: resolveAgentName(i, ''),
            user_email: i.user_email || '',
            timestamp: i.timestamp || '',
            risk_level: riskLevel,
            is_risky: RISKY_LEVELS.has(riskLevel),
          };
        }),
        total: data.total || 0,
        page: data.page || 1,
        page_size: data.page_size || 20,
      };
    } catch (error) {
      console.error('Error fetching custom-agent intent analysis:', error);
      throw error;
    }
  },

  // Populates the agent / user multi-select in the shared filter bar.
  async getSessionFilters(params = {}) {
    try {
      const { data } = await api.get(`${AI}/ai-explorer/intent-analysis/session-filters`, { params });
      return { agents: data.agents || [], users: data.users || [] };
    } catch (error) {
      console.error('Error fetching custom-agent intent session filters:', error);
      return { agents: [], users: [] };
    }
  },
};

export default customAgentsIntentService;
